import React from 'react';

// Renders a published website's standalone legal page (Privacy Policy, Terms
// of Service) at a clean top-level URL (e.g. legacytriangle.com/privacy-policy)
// instead of the long "/api/public/websites/{id}/files/privacy-policy.html"
// path. The actual HTML file is self-contained (own <html>/<style>), so it's
// embedded via an iframe — this avoids leaking that page's global CSS resets
// into the CRM's own styles while keeping the address bar clean.
const PublicLegalPage = ({ slug }) => {
  const [siteId, setSiteId] = React.useState(null);
  const [notFound, setNotFound] = React.useState(false);

  React.useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/websites/main`)
      .then((r) => (r.ok ? r.json() : null))
      .then((site) => {
        if (site && site.is_published) setSiteId(site.id);
        else setNotFound(true);
      })
      .catch(() => setNotFound(true));
  }, []);

  if (notFound) {
    return <div className="boot-splash" data-testid="legal-page-not-found">Page not found.</div>;
  }
  if (!siteId) {
    return <div className="boot-splash" data-testid="legal-page-loading">Loading…</div>;
  }
  return (
    <iframe
      title={slug}
      src={`/api/public/websites/${siteId}/files/${slug}.html`}
      data-testid={`legal-page-iframe-${slug}`}
      style={{ position: 'fixed', inset: 0, width: '100%', height: '100%', border: 'none' }}
    />
  );
};

export default PublicLegalPage;
